import { render, staticRenderFns } from "./DepartmentEditButton.vue?vue&type=template&id=162ee24f&scoped=true&"
import script from "./DepartmentEditButton.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentEditButton.vue?vue&type=style&index=0&id=162ee24f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ee24f",
  null
  
)

export default component.exports